let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3Rv9g")).then(() => parcelRequire('jfkyY'));